/* Live product search dropdown.
   Shopify's predictive search API rejects the Hebrew locale (417),
   so we fetch the regular search with a minimal JSON view instead. */
(function () {
  function debounce(fn, wait) {
    let handle;
    return function (...args) {
      clearTimeout(handle);
      handle = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function init(input) {
    if (!input || input.dataset.liveSearch) return;
    input.dataset.liveSearch = '1';

    const wrap = input.closest('form') || input.parentElement;
    wrap.style.position = 'relative';

    const box = document.createElement('div');
    box.className = 'live-search-results';
    box.hidden = true;
    wrap.appendChild(box);

    let lastQuery = '';

    const run = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) {
        box.hidden = true;
        box.innerHTML = '';
        return;
      }
      lastQuery = q;
      try {
        const res = await fetch(`/search?q=${encodeURIComponent(q)}&type=product&view=ajax`);
        if (!res.ok || lastQuery !== q) return;
        const items = await res.json();
        if (!items.length) {
          box.innerHTML = '<div class="live-search-empty">לא נמצאו מוצרים</div>';
          box.hidden = false;
          return;
        }
        box.innerHTML = items
          .map(
            (i) =>
              `<a class="live-search-item" href="${i.url}">` +
              (i.image ? `<img src="${i.image}" alt="" loading="lazy">` : '<span class="live-search-item__noimg"></span>') +
              `<span class="live-search-item__info"><span class="live-search-item__title">${i.title}</span>` +
              `<span class="live-search-item__price">${i.price}</span></span></a>`
          )
          .join('');
        box.hidden = false;
      } catch (e) {
        /* network hiccup — keep quiet */
      }
    }, 250);

    input.addEventListener('input', run);
    input.addEventListener('focus', () => {
      if (box.innerHTML) box.hidden = false;
    });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') box.hidden = true;
    });
    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) box.hidden = true;
    });
  }

  function initAll() {
    document.querySelectorAll('input[type="search"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
